import { actionCreator } from "./helpers";
import { callApi } from "./Api";
import { push } from "react-router-redux";
import isEmpty from "lodash/isEmpty";
import { pushParamsToUrl } from "../utils/utility";

export const SEGMENTS_ATTR = "SEGMENT_ATTRS";
export const SELECT_SEGMENT = "SELECT_SEGMENT";
export const ALLSTATES = "ALLSTATES";
export const selectSegment = actionCreator(SELECT_SEGMENT);
export const SET_SEGMENT_NAME = "RULE_NAME";
export const SAVE_SEGMENT = "SAVE_SEGMENT";
export const CREATE_AUDIENCE_AT_SCALE = "CREATE_AUDIENCE_AT_SCALE";
export const CREATE_AUDIENCE_AT_VISITORS = "CREATE_AUDIENCE_AT_VISITORS";
export const CLEAR_CREATE_SCALE_AUDIENCE_INFO =
  "CLEAR_CREATE_SCALE_AUDIENCE_INFO";
export const CLEAR_CREATE_VISITORS_AUDIENCE_INFO =
  "CLEAR_CREATE_VISITORS_AUDIENCE_INFO";
export const SELECTED_CITY = "SELECTED_CITY";
export const SELECTED_COUNTY = "SELECTED_COUNTY";
export const SELECTED_DMA = "SELECTED_DMA";
export const GET_CITY = "GET_CITY";
export const GET_COUNTY = "GET_COUNTY";
export const GET_DMAS = "GET_DMAS";
export const SELECTED_STATE = "SELECTED_STATE";
export const SELECTED_ALL_STATE = "SELECTED_ALL_STATE";
export const SET_PLOT_VALUES = "SET_PLOT_VALUES";
export const CLEAR_STATES = "CLEAR_STATES";
export const CLEAR_CITYS = "CLEAR_CITYS";
export const CLEAR_COUNTY = "CLEAR_COUNTY";
export const CLEAR_DMA = "CLEAR_DMA";
export const ADD_ZIPCODE = "ADD_ZIPCODE";
export const CLEAR_ALL_ZIPCODE = "CLEAR_ALL_ZIPCODE";
export const CLEAR_ZIPCODE = "CLEAR_ZIPCODE";
export const SELECTED_MAKE = "SELECTED_MAKE";
export const SELECTED_MODEL = "SELECTED_MODEL";
export const SELECTED_CC_REGION = "SELECTED_CC_REGION";
export const SELECTED_CC_LOCALE = "SELECTED_CC_LOCALE";
export const VERIFY_SEGMENT_NAME = "VERIFY_SEGEMNT_NAME";
export const CHECK_SEGMENT_LIMIT = "CHECK_SEGMENT_LIMIT";
export const GET_ALL_STATE_CITIES = "GET_ALL_STATE_CITIES";
export const LOADING = "LOADING";
export const ADD_MAKE_ACTIVE = "ADD_MAKE_ACTIVE";
export const ADD_REGION_ACTIVE = "ADD_REGION_ACTIVE";
export const GET_AUDIENCE_COUNT = "GET_COUNT";
export const GET_PLOTTED_AUDIENCE_COUNT = "GET_PLOTTED_COUNT";
export const GET_ZIPCODE_AUDIENCE_COUNT = "GET_ZIPCODE_COUNT";
export const GET_ZIPCODE_DETAIL_COUNTS = "GET_ZIPCODE_DETAIL_COUNTS";
export const CLEAR_ZIPCODE_AUDIENCE_COUNT = "CLEAR_ZIPCODE_COUNT";
export const CLEAR_AUDIENCE_COUNT = "CLEAR_AUDIENCE_COUNT";
export const CLEAR_ZIPCODE_COUNTS = "CLEAR_ZIPCODE_COUNTS";
export const CATEGORY_AUDIENCE_COUNTS = "CATEGORY_AUDIENCE_COUNTS";
export const CLEAR_CATEGORY_AUDIENCE_COUNTS = "CLEAR_CATEGORY_AUDIENCE_COUNTS";
export const SET_TARGET_HOUSEHOLD_ONLY = "SET_TARGET_HOUSEHOLD_ONLY";
export const CLEAR_ALL_AUTO = "CLEAR_ALL_AUTO";
export const CLEAR_ALL_REGION = "CLEAR_ALL_REGION";
// action for selected state
export const selectCity = (value, stateLabel, flag) => ({
  type: SELECTED_CITY,
  value,
  stateLabel,
  flag,
});
export const selectCounty = (value, stateLabel, flag) => ({
  type: SELECTED_COUNTY,
  value,
  stateLabel,
  flag,
});
export const selectDMA = (value, stateLabel, flag) => ({
  type: SELECTED_DMA,
  value,
  stateLabel,
  flag,
});
export const selectState = (value, flag) => ({
  type: SELECTED_STATE,
  value,
  flag,
});
export const selectAllState = (value, flag) => ({
  type: SELECTED_ALL_STATE,
  value,
  flag,
});
export const selectMake = (value, flag) => ({
  type: SELECTED_MAKE,
  value,
  flag,
});
export const selectModel = (value, flag) => ({
  type: SELECTED_MODEL,
  value,
  flag,
});
export const selectCultureRegion = (value, flag) => ({
  type: SELECTED_CC_REGION,
  value,
  flag,
});
export const selectCultureLocale = (value, flag) => ({
  type: SELECTED_CC_LOCALE,
  value,
  flag,
});
export const clearAllSelectedState = actionCreator(CLEAR_STATES);
export const clearAllAutoSelected = actionCreator(CLEAR_ALL_AUTO);
export const clearAllRegionSelected = actionCreator(CLEAR_ALL_REGION);
export const clearAllSelectedCity = actionCreator(CLEAR_CITYS);
export const clearAllCounty = actionCreator(CLEAR_COUNTY);
export const clearAllDMA = actionCreator(CLEAR_DMA);
export const setPlotValues = actionCreator(SET_PLOT_VALUES);
export const clearAllZipCode = actionCreator(CLEAR_ALL_ZIPCODE);
export const setSegmentName = actionCreator(SET_SEGMENT_NAME);
export const addZipCode = actionCreator(ADD_ZIPCODE);
export const clearZipCode = actionCreator(CLEAR_ZIPCODE);
export const loading = actionCreator(LOADING);
export const addMakeActive = actionCreator(ADD_MAKE_ACTIVE);
export const addRegionActive = actionCreator(ADD_REGION_ACTIVE);
export const clearAudienceCount = actionCreator(CLEAR_AUDIENCE_COUNT);
export const clearZipcodeCount = actionCreator(CLEAR_ZIPCODE_AUDIENCE_COUNT);
export const clearCreateScaleAudienceInfo = actionCreator(
  CLEAR_CREATE_SCALE_AUDIENCE_INFO,
);
export const clearCreateVisitorsAudienceInfo = actionCreator(
  CLEAR_CREATE_VISITORS_AUDIENCE_INFO,
);
export const clearCategoryAudienceCounts = actionCreator(
  CLEAR_CATEGORY_AUDIENCE_COUNTS,
);
export const setTargetHouseholdOnly = actionCreator(SET_TARGET_HOUSEHOLD_ONLY);

export const loadAttributes = (cid) => {
  return (dispatch, getState) => {
    callApi(
      dispatch,
      getState,
      SEGMENTS_ATTR,
      cid ? "attributes/tree?cid=" + cid : "attributes/tree",
    );
  };
};

export const getAllStateCities = () => {
  return (dispatch, getState) => {
    callApi(
      dispatch,
      getState,
      GET_ALL_STATE_CITIES,
      "attributes/states-with-cities",
    );
  };
};

export const getAllStates = () => {
  return (dispatch, getState) => {
    callApi(dispatch, getState, ALLSTATES, "attributes/states");
  };
};

export const getCities = (cityId) => {
  return (dispatch, getState) => {
    dispatch(loading(true));
    let startTime = new Date().getTime();
    callApi(
      dispatch,
      getState,
      GET_CITY,
      `attributes/states/${cityId}/cities`,
      { method: "GET" },
      {
        success: () => {
          dispatch(loading(false));
          localStorage.setItem("spareTime", new Date().getTime() - startTime);
        },
      },
    );
  };
};

export const getCounties = () => {
  return (dispatch, getState) => {
    callApi(dispatch, getState, GET_COUNTY, "attributes/counties");
  };
};

export const getDMAs = () => {
  return (dispatch, getState) => {
    callApi(dispatch, getState, GET_DMAS, "attributes/dmas");
  };
};
export const verifySegmentName = (clientId, name, id) => {
  const url =
    id && id > 0
      ? `segments/lookup?clientId=${clientId}&name=${name}&id=${id}`
      : `segments/lookup?clientId=${clientId}&name=${name}`;
  return (dispatch, getState) => {
    callApi(dispatch, getState, VERIFY_SEGMENT_NAME, url);
  };
};

export const verifySegmentNameAndContinue = (clientId, name, id, newURL) => {
  const url =
    id && id > 0
      ? `segments/lookup?clientId=${clientId}&name=${name}&id=${id}`
      : `segments/lookup?clientId=${clientId}&name=${name}`;
  return (dispatch, getState) => {
    callApi(
      dispatch,
      getState,
      VERIFY_SEGMENT_NAME,
      url,
      { method: "GET" },
      {
        success: () => {
          dispatch(push(newURL ? newURL : "/segment/confirm"));
        },
      },
    );
  };
};

export const verifyAndContinue = (clientId, name) => {
  const url = `clients/${clientId}/resource-limit-check?resource=segment`;
  return (dispatch, getState) => {
    callApi(
      dispatch,
      getState,
      CHECK_SEGMENT_LIMIT,
      url,
      { method: "GET" },
      {
        success: () => {
          verifySegmentNameAndContinue(clientId, name, undefined);
        },
      },
    );
  };
};

export const getAudienceCount = (data, sid) => {
  const url = sid
    ? "segments/calculate-audience" + "?sid=" + sid
    : "segments/calculate-audience";
  return (dispatch, getState) => {
    callApi(dispatch, getState, GET_AUDIENCE_COUNT, url, {
      method: "POST",
      body: JSON.stringify(data),
    });
  };
};

export const getPlottedAudienceCount = (data, sid) => {
  const url = sid
    ? "segments/calculate-audience" + "?sid=" + sid
    : "segments/calculate-audience";
  return (dispatch, getState) => {
    callApi(dispatch, getState, GET_PLOTTED_AUDIENCE_COUNT, url, {
      method: "POST",
      body: JSON.stringify(data),
    });
  };
};

export const getZipcodeAudienceCount = (data, sid) => {
  const url = sid
    ? "segments/calculate-audience" + "?sid=" + sid
    : "segments/calculate-audience";
  return (dispatch, getState) => {
    callApi(dispatch, getState, GET_ZIPCODE_AUDIENCE_COUNT, url, {
      method: "POST",
      body: JSON.stringify(data),
    });
  };
};

export const getZipcodeDetailCounts = (data, sid) => {
  const url = sid
    ? "segments/zipcode/counts" + "?sid=" + sid
    : "segments/zipcode/counts";
  return (dispatch, getState) => {
    callApi(dispatch, getState, GET_ZIPCODE_DETAIL_COUNTS, url, {
      method: "POST",
      body: JSON.stringify(data),
    });
  };
};

export const saveSegment = (data) => {
  const url = "segments";
  return (dispatch, getState) => {
    callApi(
      dispatch,
      getState,
      SAVE_SEGMENT,
      url,
      {
        method: "POST",
        body: JSON.stringify(data),
      },
      {
        success: () => {
          dispatch(clearAudienceCount());
          dispatch(push("/segment/save_success"));
        },
      },
    );
  };
};

export const getCategoryAudienceCounts = (rules, sid) => {
  const url = sid
    ? "segments/calculate-audience" + "?sid=" + sid
    : "segments/calculate-audience";
  return (dispatch, getState) => {
    callApi(dispatch, getState, CATEGORY_AUDIENCE_COUNTS, url, {
      method: "POST",
      body: JSON.stringify(rules),
    });
  };
};

export const checkSegmentLimitExceeded = (clientId) => {
  const url = `clients/${clientId}/resource-limit-check?resource=segment`;
  return (dispatch, getState) => {
    callApi(dispatch, getState, CHECK_SEGMENT_LIMIT, url);
  };
};

export const createScaleAudience = (
  name,
  tagId,
  segmentId,
  dateRange,
  segments,
) => {
  let url = `insights/${tagId}/segment-distribution/${segmentId}/audience-at-scale/${dateRange}?name=${name}`;
  if (!isEmpty(segments)) {
    url += "&segments=" + segments;
  }
  return (dispatch, getState) => {
    callApi(dispatch, getState, CREATE_AUDIENCE_AT_SCALE, url, {
      method: "POST",
    });
  };
};

export const createVisitorAudience = (
  name,
  tagId,
  segmentId,
  dateRange,
  segments,
  granularity,
  page,
) => {
  let url = `insights/${tagId}/segment-distribution/${segmentId}/website-visitors/${dateRange}?name=${name}`;
  if (!isEmpty(segments)) {
    url += "&segments=" + segments;
  }
  url = pushParamsToUrl(url, "granularity", granularity);
  if (page) {
    url = pushParamsToUrl(url, "page", page);
  }
  return (dispatch, getState) => {
    callApi(dispatch, getState, CREATE_AUDIENCE_AT_VISITORS, url, {
      method: "POST",
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/SegmentCreation.js